export const keyPrefix = 'ctv';

export const ADVERTISER_ID = 'advertiserId';
